'use client';

import * as React from 'react';
import { Disclosure, Transition } from '@headlessui/react';
import SvgPlus from '../ui/Icons/Plus';
import SvgMinus from '../ui/Icons/Minus';
import { cn } from '@/lib/utils';

export interface FAQAccordionProps {
  id: number;
  question: string;
  answer: string;
  isLast?: boolean;
}
export default function FAQAccordion({
  question,
  answer,
  isLast,
}: FAQAccordionProps) {
  return (
    <Disclosure>
      {({ open }) => (
        <div>
          <Disclosure.Button
            className={cn(
              'flex w-full items-center justify-between rounded-[10px] border border-gray-200 p-7 hover:bg-gray-100',
              isLast && 'faded-out '
            )}
          >
            <span className="w-fit text-left text-h5 font-bold text-title ">
              {question}
            </span>
            {open ? (
              <SvgMinus className="h-5 w-5 text-gray-300" />
            ) : (
              <SvgPlus className="h-5 w-5 text-gray-300" />
            )}
          </Disclosure.Button>
          <Transition
            enter="transition duration-100 ease-out"
            enterFrom="transform scale-95 opacity-0"
            enterTo="transform scale-100 opacity-100"
            leave="transition duration-75 ease-out"
            leaveFrom="transform scale-100 opacity-100"
            leaveTo="transform scale-95 opacity-0"
          >
            <Disclosure.Panel className="rounded-[10px] bg-white p-4">
              <div
                className="w-full min-w-full text-base leading-[150%]"
                dangerouslySetInnerHTML={{
                  __html: answer,
                }}
              />
            </Disclosure.Panel>
          </Transition>
        </div>
      )}
    </Disclosure>
  );
}
